import React from 'react';
import PropTypes from 'prop-types';

import Input from './Input';

const InputText = ({
  label,
  id,
  value,
  onChange,
  onBlur,
  required = false,
  maxLength,
  disabled = false,
  dataTest,
  placeholder,
  error,
  bottomMarginSizing,
  icon
}) => {
  return (
    <Input
      label={label}
      id={id}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      required={required}
      maxLength={maxLength}
      disabled={disabled}
      error={error}
      type="text"
      dataTest={dataTest}
      placeholder={placeholder}
      bottomMarginSizing={bottomMarginSizing}
      icon={icon}
    />
  );
};

InputText.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  dataTest: PropTypes.string.isRequired,
  value: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  bottomMarginSizing: PropTypes.oneOf([1, 0, undefined])
};

export default InputText;
